import React from 'react'
import { func, object, array } from 'prop-types'

import ItemEditor from './ItemEditor'


function ItemsEditor (props) {
  const { value, spliter, style } = props

  return (
    <div className={style['form-container']}>
      <div className={style.items}>
        <div className={`${style['items-head']} ${style.row}`}>
          <div className={style.title}> 序號 </div>
          <div className={style.title}> 品名 </div>
          <div className={style.title}> 規格 </div>
          <div className={style.title}> 單價 </div>
          <div className={style.title}> 數量 </div>
          <div className={style.title}> 小計 </div>
          <div className={style.title}> 備註 </div>
        </div>
        {
          value.map((v, i) => (
            <ItemEditor
              key={v._id}
              index={i}
              {...spliter(props)(i)}
              style={style}
            />
          ))
        }
      </div>
    </div>
  )
}

ItemsEditor.propTypes = {
  value: array.isRequired,
  spliter: func.isRequired,
  schema: object.isRequired,
  style: object.isRequired,
}

export default ItemsEditor



// WEBPACK FOOTER //
// ./src/components/SalesOrderEditor/ItemsEditor/ItemsEditor.jsx